import { useCallback, useEffect, useState } from "react";
import { User } from "../Entities/User";
import { useLoader } from "../Context/LoaderContext";
import userService from "../Service/user.service";
import { JobApplication } from "../Entities/JobApplication";
import { UserProfile } from "../Entities/UserProfile";

const useCandidate = (candidateId: string | null) => {
  const { setLoading, setLoadingMessage } = useLoader();
  const [candidate, setCandidate] = useState<User | null>(null);
  const [recentApplication, setRecentApplication] = useState<JobApplication | null>(null);
  const [recentResume, setRecentResume] = useState<UserProfile | null>(null);

  const getCandidate = useCallback(async () => {
    if (!candidateId) {
      return;
    }
    try {
      setLoading(true);
      setLoadingMessage("Loading talent pool details...");
      const candidateResponse = await userService.getCandidateInfo(candidateId);
      if (candidateResponse) {
        const { latestApplication, latestProfile, ...user } = candidateResponse;
        setCandidate(user);
        setRecentApplication(latestApplication ?? null);
        setRecentResume(latestProfile ?? null);
      } else {
        console.error(
          "~ useCandidate ~ Inavlid talentPoolResponse:",
          candidateResponse,
        );
        setCandidate(null);
      }
    } catch (error) {
      console.error("~ useCandidate - getCandidate ~ error:", error);
      setCandidate(null);
      setRecentApplication(null);
      setRecentResume(null);
    } finally {
      setLoading(false);
      setLoadingMessage(null);
    }
  }, [candidateId, setLoadingMessage, setLoading]);

  useEffect(() => {
    getCandidate();
  }, [getCandidate]);

  return {
    candidate,
    recentApplication,
    recentResume,
  };
};
export default useCandidate;
